// src/components/CipEquity.jsx
import React, { useState, useContext } from 'react';
import EquityNivoBarChart from './EquityNivoBarChart';
import { ProductsContext } from '../context/products.context';
import OptionsSchoolCipEquity from './OptionsSchoolCipEquity';
import CipEquityYearSelector from './CipEquityYearSelector';

const CipEquity = ({ cip, cipEquityData, schoolDemographic }) => {
  const { listSchools, cipDoc } = useContext(ProductsContext);

  // Track "Show Missing" toggle state
  const [showMissing, setShowMissing] = useState(true);

  // Check if required data is available
  if (!cipEquityData) {
    return (
      <div className="max-w-[1200px] border-t-zinc-300 border-t border-dashed bg-zinc-50 -mx-4 p-8">
        <div className="text-center text-gray-600">
          No equity data available for this CIP.
        </div>
      </div>
    );
  }

  if (!schoolDemographic) {
    return (
      <div className="max-w-[1200px] border-t-zinc-300 border-t border-dashed bg-zinc-50 -mx-4 p-8">
        <div className="text-center text-gray-600">
          No demographic data available for comparison.
        </div>
      </div>
    );
  }

  // Get CIP name for display
  const cipName = cipDoc?.cipDetails?.cipName || cip;

  return (
    <div className="max-w-[1200px] border-t-zinc-300 border-t border-dashed bg-zinc-50 -mx-4">
      {/* Header */}
      <div className="p-4 z-10">
        <h1 className="text-2xl font-bold text-gray-800 py-2">Student Demographics Analysis</h1>
        <p className="text-gray-600 mb-4">
          Compare {cipName} enrollment demographics with overall school/district demographics
        </p>

        {/* Selector Controls */}
        <div className="mx-auto px-4 flex items-center py-2 z-10">
          <div className="flex-1 flex justify-center">
            <OptionsSchoolCipEquity availableSchools={listSchools} cipEquityData={cipEquityData} />
          </div>
          <div className="flex-1 flex justify-center">
            <CipEquityYearSelector cipEquityData={cipEquityData} />
          </div>
          <div className="flex-1 flex justify-center">
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={showMissing}
                onChange={() => setShowMissing(!showMissing)}
                className="rounded text-indigo-600 focus:ring-indigo-500"
              />
              <span className="text-sm text-gray-700">Show Enrollment Gaps</span>
            </label>
          </div>
        </div>
      </div>

      {/* Charts Section */}
      <div className="grid gap-6 grid-cols-1 w-full p-4">
         
                {/* Chart 1: Special Student Groups */}
          <div className="bg-white  rounded-lg p-6 shadow-md">
            <EquityNivoBarChart 
              cipEquityData={cipEquityData} 
              schoolDemographic={schoolDemographic}
              focus="Gender & Special Student Groups"
              studentGroups={[
                'Male', 'Female', 'X',
                'Economically Disadvantaged',
                'English Learners',
                'Homeless',
                'Migrant',
                'Military Parent',
                'Section504',
                'Students w/ Disabilities',
              ]}
              showMissing={showMissing}
            />
          </div>
           {/* Chart 2: Ethnicity Groups */}
           <div className="bg-white  rounded-lg p-6 shadow-md">
            <EquityNivoBarChart 
              cipEquityData={cipEquityData} 
              schoolDemographic={schoolDemographic}
              focus="Race/Ethnicity"
              studentGroups={[
                'American Indian/Alaskan Native',
                'Asian',
                'Black/African American',
                'Hispanic/Latino',
                'Native Hawaiian/Other Pacific Islander',
                'Two or More Races',
                'White',
              ]}
              showMissing={showMissing}
            />
          </div>
        </div>
    </div>
  );
};

export default CipEquity;